import { z } from "zod";

import { systemFields, zDate, zMedia } from "@/lib/zod/show-fragments";

const zTeamCopy = z
  .object({
    id: z.string().nullish(),
    name: z.string().nullish(),
    shortName: z.string().nullish(),
    media: zMedia.nullish(),
  })
  .passthrough();

/** Read-only view schema for the Matches show page — full MatchDbDto. */
export const matchViewSchema = z
  .object({
    id: z.string(),
    sport: z.string().nullish(),
    leagueId: z.string().nullish(),
    homeTeamId: z.string().nullish(),
    awayTeamId: z.string().nullish(),
    league: z
      .object({
        id: z.string().nullish(),
        name: z.string().nullish(),
        country: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    homeTeam: zTeamCopy.nullish(),
    awayTeam: zTeamCopy.nullish(),
    venueId: z.string().nullish(),
    venue: z
      .object({ id: z.string().nullish(), name: z.string().nullish() })
      .passthrough()
      .nullish(),
    venueSource: z.string().nullish(),
    startDate: zDate,
    season: z.string().nullish(),
    round: z.string().nullish(),
    state: z.string().nullish(),
    status: z.string().nullish(),
    homeScore: z.number().nullish(),
    awayScore: z.number().nullish(),
    ticketUrl: z.string().nullish(),
    pricing: z
      .array(
        z
          .object({
            label: z.string().nullish(),
            amount: z.number().nullish(),
            currency: z.string().nullish(),
          })
          .passthrough(),
      )
      .nullish(),
    tags: z.array(z.string()).nullish(),
    hide: z.boolean().nullish(),
    metadata: z
      .object({
        source: z.string().nullish(),
        sourceId: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    ...systemFields,
  })
  .passthrough();

export type MatchViewType = z.infer<typeof matchViewSchema>;
